import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { DataInput } from '@integration-app/react';
import { useFieldMappingInstanceContext } from '../contexts';
export function ExportFieldMappingInstanceConfig() {
    const { fieldMappingInstance, patch } = useFieldMappingInstanceContext();
    const { dataSourceSchema, exportValue, appSchema, frozenExportFields } = fieldMappingInstance;
    return (_jsx(_Fragment, { children: _jsx(DataInput, { value: exportValue, schema: dataSourceSchema, variablesSchema: appSchema, frozenFieldsLocators: frozenExportFields, onChange: (exportValue) => patch({ exportValue }), hideReadOnlyFields: true }) }));
}
//# sourceMappingURL=ExportFieldMappingInstanceConfig.js.map